module.exports = __webpack_public_path__ + "static/values-96b359442baf249b0c657884b6332f7a.svg";